<template>
  <div class="case-page">
    <div class="banner ban_title"><h1>精选案例</h1></div>
    <div class="pc_content">
      <div class="con">
        <Cases :datalist="cases"></Cases>
        <!-- <p class="caselist_null" v-else>{{ tips }}</p> -->
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Case',
  components: {
    Cases: () => import('../componentsNew/Cases.vue')
  },
  data () {
    return {
      tips: '加载中···', // 敬请期待
      cases: []
    }
  },
  created () {
    if (this.$route.name && this.$route.name.includes('Case')) {
      this.$nextTick(() => {
        this.getCases()
      })
    }
  },
  methods: {
    getCases: function () {
      let curl = this.global.urlNew.course['all'] + this.global.area_id
      this.$http
        .jsonp(curl)
        .then(data => {
          return data.json()
        })
        .then(data => {
          // console.log("cases ", data);
          if ((data.errno === 0 || data.errno === '0') && data.data && data.data.length > 0) {
            this.cases = data.data
          } else {
            this.tips = '敬请期待'
            this.getAllCase()
          }
        })
        .catch(err => {
          console.log(err)
          this.tips = '敬请期待'
        })
    }
  }
}
</script>

<style lang="scss">
#app .case-page {
  .pc_content {
    .con {
      margin-top: 0;
      margin-bottom: 0;
      padding-top: 90px;
      padding-bottom: 60px;
      .caselist_null {
        width: 100%;
        font-size: 20px;
        text-align: center;
        margin-top: 0;
        margin-bottom: 0;
        padding-top: 20px;
      }
    }
  }
  // @media (max-width:600px) {
  @media (max-width: 767px) {
    .pc_content {
      .con {
        margin-top: 45px;
        margin-bottom: 0;
        padding-top: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/Case.vue